import { z } from "zod";
import { TeamRoles } from "./team-roles.ts";
import {
  BillingAccountCustomPricingDto,
  SubscriptionTierType,
} from "./billing.ts";
import { CouponDto } from "./coupon.ts";

export const PublicSettingsDto = z.object({
  maxImagesInVideo: z.number().optional(),
});

export const CreateTeamDto = z.object({
  name: z.string(),
});

export const UpdateTeamDto = z.object({
  name: z.string().min(1, {
    message: "Team name is required",
  }),
});

export const TeamFeatureFlagsDto = z.object({
  creditDialogInitialTab: z.enum(["SUBSCRIPTION", "ONE_OFF"]).optional(),
});

export const TeamBillingInfoDto = z.object({
  showCredits: z.boolean(),
  creditBalance: z.number(),
  activeSubscription: z
    .object({
      stripeStatus: z.string(),
      tier: SubscriptionTierType,
    })
    .nullable(),
  autoApplyCoupon: CouponDto.nullable(),
  customPricing: BillingAccountCustomPricingDto.nullable(),
});

export const TeamDto = z.object({
  externalId: z.string(),
  name: z.string().nullable(),
  publicSettings: PublicSettingsDto.nullable(),
  featureFlags: TeamFeatureFlagsDto,
  billingInfo: TeamBillingInfoDto,
  isDfyEditorTeam: z.boolean(),
});

export const TeamMembersDto = z.object({
  members: z.array(
    z.object({
      firstName: z.string().nullable(),
      lastName: z.string().nullable(),
      userExternalId: z.string(),
      externalId: z.string(),
      role: z.enum(TeamRoles),
      contactEmail: z.string(),
    }),
  ),
  invites: z.array(
    z.object({
      externalId: z.string(),
      role: z.enum(TeamRoles),
      email: z.string(),
    }),
  ),
});

export const UpdateTeamMemberDto = z.object({
  role: z.enum(TeamRoles),
});

export type PublicSettingsDto = z.infer<typeof PublicSettingsDto>;
export type CreateTeamDto = z.infer<typeof CreateTeamDto>;
export type TeamFeatureFlagsDto = z.infer<typeof TeamFeatureFlagsDto>;
export type TeamBillingInfoDto = z.infer<typeof TeamBillingInfoDto>;
export type TeamDto = z.infer<typeof TeamDto>;
export type UpdateTeamDto = z.infer<typeof UpdateTeamDto>;
export type TeamMembersDto = z.infer<typeof TeamMembersDto>;
export type UpdateTeamMemberDto = z.infer<typeof UpdateTeamMemberDto>;
